<rask-page pageTitle="Redigera checklista" noPadding>
    <ng-container header>
        <rask-action-button icon="fas fa-plus" (click)="openEditFragaModal()">
            <rask-header noPadding>Lägg till fråga</rask-header>
        </rask-action-button>
        <rask-action-button icon="fas fa-plus" (click)="openAddGruppModal()">
            <rask-header noPadding>Lägg till grupp</rask-header>
        </rask-action-button>
    </ng-container>
    @if(grupperWithFragor.length > 0){
    <rask-tabs>
        @for (grupp of grupperWithFragor; track $index) {
        <rask-tab [label]="grupp.gruppNamn">
            <rask-sysadm-checklista-item
                [grupp]="grupp"
                (rowClicked)="openEditFragaModal($event)"
                (removed)="onGruppRemoved(grupp)">
            </rask-sysadm-checklista-item>
        </rask-tab>
        }
    </rask-tabs>
    }
</rask-page>